import { render, staticRenderFns } from "./SubmittalDetails.vue?vue&type=template&id=0e9a1584&scoped=true&lang=pug&"
import script from "./SubmittalDetails.vue?vue&type=script&lang=js&"
export * from "./SubmittalDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubmittalDetails.vue?vue&type=style&index=0&id=0e9a1584&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9a1584",
  null
  
)

export default component.exports